import type { TreeNodeType } from '@/shared/lib/tree'

import React, { useMemo } from 'react'

import { Tag } from '@/shared/components/ui/tag'
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from '@/shared/components/ui/tooltip'
import { findAllNodes } from '@/shared/lib/tree'

export function BasicTreeField({
	value,
	choices,
}: {
	value: string[] | null | undefined
	choices: TreeNodeType[]
}) {
	const { names } = useMemo(() => {
		const nodes = findAllNodes(
			(choices as TreeNodeType[]) || [],
			value as string[]
		)
		const names = nodes.map((node) => node.name)

		return {
			nodes,
			names,
		}
	}, [value, choices])

	return (
		<Tooltip delayDuration={500}>
			<TooltipTrigger asChild>
				<Tag>{names.join(' / ')}</Tag>
			</TooltipTrigger>
			<TooltipContent side='left'>
				<ul className='my-0'>
					{names.map((name) => (
						<li key={name}>{name}</li>
					))}
				</ul>
			</TooltipContent>
		</Tooltip>
	)
}
